import type { DataRow, FilterState } from "../types";
import { reportedDate } from "./globalDateRange";

export function applyFilters(rows: DataRow[], filters: FilterState): DataRow[] {
  const query = filters.search.trim().toLocaleLowerCase("th");
  return rows.filter((row) => {
    if (filters.workTypes.length && !filters.workTypes.includes(row.workType ?? "ไม่ระบุ")) return false;
    if (filters.status !== "ทั้งหมด" && row.status !== filters.status) return false;
    if (filters.team !== "ทั้งหมด" && row.team !== filters.team) return false;
    const date = reportedDate(row);
    if (filters.dateFrom && (!date || date < filters.dateFrom)) return false;
    if (filters.dateTo && (!date || date > filters.dateTo)) return false;
    if (query && ![
      row.jobId, row.dmaCode, row.branchNumber, row.branchShortName, row.branchFullName,
      row.workType, row.team, row.status, row.road, row.soi, row.address,
      row.reportedDetail, row.workDetail,
    ].some((value) => String(value ?? "").toLocaleLowerCase("th").includes(query))) return false;
    return true;
  });
}

export function distinctJobCount(rows: DataRow[]): number {
  return new Set(rows.map((row) => row.jobId).filter(Boolean)).size;
}

export function aggregateByDma(rows: DataRow[]): Map<string, number> {
  const jobs = new Map<string, Set<string>>();
  for (const row of rows) {
    if (!row.dmaCode) continue;
    const set = jobs.get(row.dmaCode) ?? new Set<string>();
    set.add(row.jobId ?? row.__rowId);
    jobs.set(row.dmaCode, set);
  }
  return new Map([...jobs].map(([dma, ids]) => [dma, ids.size]));
}

export function categoryCounts(rows: DataRow[], field: "status" | "workType" | "team"): { label: string; value: number }[] {
  const counts = new Map<string, number>();
  for (const row of rows) {
    const label = row[field] || "ไม่ระบุ";
    counts.set(label, (counts.get(label) ?? 0) + 1);
  }
  return [...counts].map(([label, value]) => ({ label, value })).sort((a, b) => b.value - a.value);
}

export function quantileBreaks(values: number[], classes: number): number[] {
  if (!values.length || classes < 1) return [];
  const sorted = [...values].sort((a, b) => a - b);
  return Array.from({ length: classes + 1 }, (_, index) => {
    const position = (sorted.length - 1) * (index / classes);
    const lower = Math.floor(position);
    const upper = Math.ceil(position);
    const weight = position - lower;
    return sorted[lower] * (1 - weight) + sorted[upper] * weight;
  });
}

